import { FormCard, HomeType, HomeTypeExplorer, HomeWidgetsDefaultForm, HomeWidgetsForm } from '../../types/home';
import { HomeWidgetPayload } from '../../repository/mytm/home/homeWidgetsRepository';

export const toPayloadHomeWidgets = (values: HomeWidgetsForm & HomeWidgetsDefaultForm): HomeWidgetPayload => {
  return {
    groupKey: values.groupKey,
    name: values.name || '',
    type: values.type,
    heading: values.heading,
    title: values.title ? values.title.trim() : '',
    description: values.description ? values.description.trim() : values.description,
    backgroundColor: values.backgroundColor ? values.backgroundColor.trim() : values.backgroundColor,
    backgroundImage: values.backgroundImage,
    contentType: values.contentType ? values.contentType.trim() : null,
    contentId: values.contentId && values.contentId.toString().trim() !== '' ? Number(values.contentId) : null,
    productId: values.productId ? values.productId.trim() : null,
    contentFormat: values.contentFormat ? values.contentFormat.trim() : null,
    ctaText: values.ctaText ? values.ctaText.trim() : null,
    ctaLink: values.ctaLink ? values.ctaLink.trim() : null,
    status: values.status,
    extraData: values.extraData,
    show: values.show,
    category: values.category || null,
    colorOpacity: values?.colorOpacity || values?.colorOpacity === 0 ? values?.colorOpacity : null,
    textColor: values?.textColor || null,
    buttonAlign: values?.buttonAlign || null,
    textAlign: values?.textAlign || null,
    countries: values?.countries || null,
  };
};

export const convertTemplateHomeTiles = (type: HomeType | HomeTypeExplorer): string => {
  let typeConverted = '';
  switch (type) {
    case HomeType.TARGET_SCORE:
      typeConverted = 'TARGET';
      break;
    case HomeType.AVERAGE_SCORE:
      typeConverted = 'AVERAGE';
      break;
    default:
      typeConverted = type;
      break;
  }

  return typeConverted;
};

export const toCategoryFormByHomeType = (record: any) => {
  if (!record?.type) {
    return FormCard.TEMPLATE;
  }
  const { type } = record;
  let stage: FormCard;
  switch (type) {
    case HomeType.PROMOTION: {
      stage = FormCard.JUST_IN;
      break;
    }
    case HomeType.INSIGHT_OVERVIEW:
      stage = FormCard.INSIGHTS;
      break;
    case HomeType.HANDICAP_INDEX:
      stage = FormCard.HANDICAP;
      break;
    case HomeType.AVERAGE_SCORE:
      stage = FormCard.SCORE;
      break;
    case HomeType.TARGET_SCORE:
      stage = FormCard.TARGET;
      break;
    default:
      stage = FormCard.TEMPLATE;
      break;
  }
  return stage;
};
